import { call, fork, put, select, take } from 'redux-saga/effects'
import { isCustomHeaderAndFooterCustomer } from '../../helpers/utils'
import { fetchHeader } from './actions'
import { FETCH_HEADER_DATA } from './constants'
import { fetchHeaderApi } from './services'

function* headerWorker(language, version) {
  const state = yield select()
  const customer = state.devicebits.customer
  if (!isCustomHeaderAndFooterCustomer(customer)) return

  try {
    const response = yield call(fetchHeaderApi, language, version)
    if (Object.keys(response).includes('items')) {
      yield put(fetchHeader.success(response))
    }
  } catch (e) {
    yield put(fetchHeader.failure(e))
  }
}

function* headerWatcher() {
  while (true) {
    const { language, version } = yield take(FETCH_HEADER_DATA['REQUEST'])
    yield call(headerWorker, language, version)
  }
}

export default function* rootSaga() {
  yield fork(headerWatcher)
}



// WEBPACK FOOTER //
// ./src/containers/Header/sagas.js